import { GET_COUPON_ASSIGNED_STATUS, GET_COUPON_ASSIGNED_STATUS_SUCCESS, GET_COUPON_ASSIGNED_STATUS_ERROR } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCouponAssignedStatusList = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_ASSIGNED_STATUS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_COUPON_ASSIGNED_STATUS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_COUPON_ASSIGNED_STATUS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCouponAssignedStatusList;
